/* Global imports */
import pt from 'prop-types';
import React, { useContext, useRef, useState } from 'react';
import { MicrocopyContext } from '../../../context/microcopy.context';
import { getCopy } from '../../../helpers/copy';
import { combine } from '../../../helpers/styles';
import Icon from '../../ui/icon';
import * as styles from './form.module.scss';
import Text from '/src/components/ui/text';

const CMSForm = ({
  inputLabel,
  inputPlaceholder,
  btnLabel,
  type,
  action,
  inputClassName,
  btnClassName,
  className,
  onFooter,
}) => {
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const form = useRef();
  const formInput = useRef();
  const microcopy = useContext(MicrocopyContext);

  const [value, setValue] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    fetch(action, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ [type]: value }),
    }).then((res) => setSuccess(res.status === 200));
  };

  return !success ? (
    <form
      ref={form}
      onSubmit={handleSubmit}
      className={combine(styles.form, onFooter && styles.onFooter, className)}
    >
      {inputLabel && (
        <Text as="label" type="metanavi" className={styles.inputLabel}>
          {inputLabel}
        </Text>
      )}
      <div className={styles.inputContainer}>
        <input
          ref={formInput}
          type={type}
          name={type}
          placeholder={inputPlaceholder}
          className={combine(styles.formInput, inputClassName)}
          onChange={(e) => setValue(e.target.value)}
          required
          value={value}
        />

        <button
          className={combine(styles.formButton, btnClassName)}
          disabled={loading}
        >
          <Text as="span" type="button">
            {btnLabel}
          </Text>
        </button>
      </div>
    </form>
  ) : (
    <div className={styles.successWrapper}>
      <div className={styles.iconWrapper}>
        <Icon name={'check'} size={'2x'} color={'#e60046'} />
      </div>
      <span>{getCopy('newsletterSignup.success', microcopy)}</span>
    </div>
  );
};

export const proptypes = {
  inputLabel: pt.string,
  inputPlaceholder: pt.string,
  type: pt.string,
  btnLabel: pt.string.isRequired,
  action: pt.string.isRequired,
  inputClassName: pt.string,
  btnClassName: pt.string,
  className: pt.string,
  onFooter: pt.bool,
};
CMSForm.propTypes = proptypes;
CMSForm.defaultProps = {
  inputLabel: '',
  inputPlaceholder: '',
  type: 'text',
  btnLabel: '',
  inputClassName: '',
  btnClassName: '',
  className: '',
  onFooter: false,
};

export default CMSForm;
